import store from '@/store'
import { mapTasks } from '@/utils/tasks'
import { mapEvents } from '@/utils/events'

const state = {
  taskSortProp: 'taskString',
  taskSortAscending: true
}

const mutations = {
  setTaskSortProp (state, prop) {
    state.taskSortProp = prop
  },
  setTaskSortAscending (state, ascending) {
    state.taskSortAscending = ascending
  },
  toggleTaskSortAscending (state) {
    state.taskSortAscending = state.taskSortAscending !== true
  }
}

const getters = {
  taskSortProp: state => state.taskSortProp,
  taskSortAscending: state => state.taskSortAscending,
  filteredTasks: () => {
    let filter = store.getters.selectedTaskFilter
    let isMyWorkSelected = filter === 0
    let isActiveSelected = filter === 1
    let allTasks = store.getters['tasks/all']
    let allEvents = store.getters['events/all']
    let filteredTasks = allTasks.filter(task => {
      let isDeleted = task.attributes.isDeleted
      let isActive = !isDeleted && !task.attributes.isDone && !task.attributes.isOnHold
      let isAssigned = isActive && task.relationships.assignedUsers.data.filter(user => ['0', '-1', store.state.authentication.user.id].includes(user.id)).length

      return isMyWorkSelected ? isAssigned : isActiveSelected ? isActive : !isDeleted
    })

    let filteredEvents = allEvents.filter(event => {
      let isDeleted = event.attributes.isDeleted
      let isActive = !isDeleted && !event.attributes.isDone && !event.attributes.isOnHold
      let isAssigned = isActive && event.relationships.assignedUsers.data.filter(user => ['0', '-1', store.state.authentication.user.id].includes(user.id)).length

      return isMyWorkSelected ? isAssigned : isActiveSelected ? isActive : !isDeleted
    })

    return mapTasks(filteredTasks).concat(mapEvents(filteredEvents))
  }
}

export default {
  state,
  mutations,
  getters
}
